/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2IconVerticalMenu/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2IconVerticalMenu({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2IconVerticalMenu",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 4,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2IconVerticalMenu.Svg"
  data-view-path={viewPath}
 viewBox="0 0 4 14"
 style={{'--as-1-22TH24': alignSelf,'--mt-2-22TH24': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-22TH24': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-22TH24': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-22TH24': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-22TH24': opacity,'--w-10-22TH24': typeof width === 'number' ? `${width}px` : width,'--h-11-22TH24': typeof height === 'number' ? `${height}px` : height,'--f-12-22TH24': fill,'--a-7-22TH24': isAnimated ? animation : "none",'--sd-8-22TH24': isAnimated ? strokeDashoffset : 0,'--sd-9-22TH24': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2IconVerticalMenu.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4 2a2 2 0 11-4 0 2 2 0 014 0zm0 5a2 2 0 11-4 0 2 2 0 014 0zm-2 7a2 2 0 100-4 2 2 0 000 4z"
 style={{'--f-12-22TH24': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}